import styled from 'styled-components';

export const VoiceLanguageContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  justify-content: center;
`;

export const SmallAvatarStyled = styled.img`
  width: 24px;
  height: 24px;
  border-radius: 50%;
  object-fit: contain;
`;
